
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/cctv",
      function () {
        return require("private-next-pages/services/cctv.tsx");
      }
    ]);
  